import React, { Component } from 'react';
import PropTypes from 'prop-types';

// TODO
// Create a file type object which contains
// - a method to retrieve the file itself
// - a name / fake path
// - a base64 value
// - a type

// this file type can be passed back and forth between the parent component and this one
// and the parent component can then upload the file itself

class FileUpload extends Component {

  constructor(...args) {
    super(...args);
    this.state = {
      value: '',
      fileType: '',
      base64: '',
    };
  }

  componentWillMount() {
    this.fileStore = {};
  }

  handleChange = (ev) => {
    ev.persist();
    const files = ev.target.files;
    const file = files[0];
    const value = ev.target.value;
    this.setState({
      value,
      fileType: file.type,
    }, () => {
      // read as binary string, and keep in store somewhere
      // this.fileStore[this.state.value] = files;
      this.readFileAsBase64(file).then(base64 => {

        this.setState({
          base64,
        });

        // store the actual file in the file store
        this.fileStore[value] = file;
        this.forceUpdate();

        // notify the listening parent
        if ( typeof this.props.onChange === "function" ) {

          this.props.onChange({
            name: file.name,
            size: file.size,
            type: file.type,
            getFile: this.getFile,
          });

        }

      });
    });
  }

  getFile = () => {
    return this.fileStore[this.state.value] ? this.fileStore[this.state.value] : null;
  }

  readFileAsBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        reject(error);
      };
    });
  }

  isImage(type) {
    return type.indexOf("image") > -1;
  }

  render() {

    const {name, type} = this.props;
    const {value, fileType, base64} = this.state;

    return (
      <div>
        {value.length > 0 && (
          <div>
            {(type === "img" || this.isImage(fileType)) && (
              <img src={base64} height="100px" alt="Uploaded" />
            )}
          </div>
        )}
        <input className="FileUpload" type="file" name={name} onChange={this.handleChange} value={value} />
      </div>
    );

  }

}

FileUpload.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.oneOf([
    "img",
  ]),
}

export default FileUpload;



// WEBPACK FOOTER //
// ./src/component/molecules/FileUpload/index.js